import { createContext } from "react";
import { useState } from "react";
 export const accContext = createContext({})

const Wrapper =(props)=>{
    const [acclogin, setAcclogin] = useState({
        provider: null,
        signer: null,
        accountAddress: null,
      });



      function addData(provider, signer, accountAddress) {
        setAcclogin((prevState) => {
          return {
            provider,
            signer,
            accountAddress,
          };
        });


      }

      const sharedData = {
        addData,
        acclogin,
        
      }
      return (
        <accContext.Provider value={{sharedData}}>
          {props.children}
        </accContext.Provider>
      )
}

export default Wrapper;